(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6153],{

/***/ 55660:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/contact-us",
      function () {
        return __webpack_require__(23548);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ ContactUsWeb; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_misc_contact_us_ContactUs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6503);
/* harmony import */ var components_service_pages_constants_company_pages_methods__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24145);




var __N_SSG = true;
function ContactUsWeb() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_misc_contact_us_ContactUs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
};
ContactUsWeb.getLayout = components_service_pages_constants_company_pages_methods__WEBPACK_IMPORTED_MODULE_3__/* .getContactUsPageLayout */ .sA;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8880,9774,2888,179], function() { return __webpack_exec__(55660); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);